/*
* Client detail view for authenticated users
*/

import * as _ from 'lodash';
import * as React from 'react';
import { Button, ButtonToolbar, Row, Well } from 'react-bootstrap';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import { compose } from 'redux';
import { connectRequest } from 'redux-query';

import * as MutateActions from '../actions/mutate';
import * as AppComp from '../common/app-component-base';
import * as AppUtilities from '../common/apputilities';
import CopyAddressToClipboard from '../common/copyaddresstoclipboard';
import EntityNotes from '../common/entitydetail/entitynotes';
import ApiEndpoints from '../config/apiendpoints';
import * as LK from '../config/apilookupkeys';
import * as ReduxQueries from '../queries';
// import GoogleMapLink from '../common/googlemaplink';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { AddressSection, EntityDetailSection, SectionField } from '../common/entitydetail/entitydetailsection';
import { Formatters } from '../common/formatters';
import { FormCheckbox } from '../common/formcheckbox';
import GoogleMapEmbed from '../common/googlemapembed';
import { EmailLinkComponent, NavigationLinks, NavLinkComponent } from '../common/navigation';
import { SelectOptions } from '../common/selectOptions';
import { WhiteBoxPageSection } from '../common/whiteboxpagesection';

export interface IClientDetailProps extends AppComp.IAppComponentProps {
    client: any;
    clientId: any;
    associations: any[];
    navigateTo?: any;
}

const UNKNOWN_CONTACT = 'UNKNOWN CONTACT';

class Client extends AppComp.AppComponent<IClientDetailProps, any> {
    public FormModelName: string = 'addClientContact';

    public formDispatch: any;

    public constructor(props: any) {
        super(props, 'app.client-detail.');
    }

    public renderContacts(contacts: Array<any>) {
        if (!AppUtilities.isArrayWithLength(contacts)) { return []; }

        return _.map(_.orderBy(contacts, [contact => contact.lastName ? contact.lastName.toLowerCase() : contact.firstName ? contact.firstName.toLowerCase() : ''], ['asc']), (c: any, i) => {
            try {
                let contactLines: Array<any> = [];

                const contactInfo = Formatters.composeClientContactFormal(c);
                contactLines.push(contactInfo || UNKNOWN_CONTACT);
                if (!contactInfo && c.notes && c.notes.length > 0) {
                    contactLines.push(c.notes[0].notes);
                }

                let emailPhone = _.stubArray();
                const email = _.get(c, 'email');
                if (email) {
                    const link = (<EmailLinkComponent key={`client-email-${i}`} email={email} caption={`${this.appText('app.common.contacts.send-email-to', false)} ${email}`} />);
                    emailPhone.push(link);
                }

                if (_.get(c, 'phone')) {
                    const phoneFormatted = Formatters.formatPhoneNumber(_.get(c, 'phone'), 'US');
                    emailPhone.push(<span key={`client-phone-${i}`}>&nbsp;{phoneFormatted}</span>);
                }

                contactLines.push(<div key={`client-contact-wrapper-${i}`}>{emailPhone}</div>);

                return this.renderClientCard(contactLines, i);
            } catch {
                return UNKNOWN_CONTACT;
            }
        });
    }

    public renderAssociations(associations: Array<any>) {
        if (!AppUtilities.isArrayWithLength(associations)) { return []; }

        return _.orderBy(associations, [association => _.get(association, 'name', '').toLowerCase()], ['asc']).map((c, i) => {
            let assocLines: Array<any> = [];

            const link = (
                <NavLinkComponent
                    caption={_.get(c, 'name')}
                    linkDetails={{ to: NavigationLinks.associationDetail(_.get(c, 'associationId')), title: this.appText('view-association') }}
                />
            );
            assocLines.push(link);

            const location = _.get(c, 'location');
            if (location) {
                let addr = '';
                if (_.get(location, 'address1')) { addr += _.get(location, 'address1'); }
                if (_.get(location, 'address2')) { addr += ' ' + _.get(location, 'address2'); }

                const address = Formatters.composeLocationCityStateZipCountry(location);
                if (address) { addr += ' ' + address; }
                assocLines.push(addr);
            }

            return this.renderClientCard(assocLines, i);
        });
    }

    public renderClientCard(cardLines: Array<any>, index: number) {
        if (!AppUtilities.isArrayWithLength(cardLines)) { return; }

        return (
            <Row key={index}>
                <Col xs={12}>
                    <div className="client-array-card">
                        {cardLines.map((l, li) => {
                            return (<div key={li}>{l}</div>);
                        })}
                    </div>
                </Col>
            </Row>
        );
    }

    public attachDispatch(d: any) {
        this.formDispatch = d;
    }

    public onFormSubmit(values: any) {
        // Process form submission

        const newContact = {
            email: _.get(values, 'email'),
            firstName: _.get(values, 'firstName'),
            inactive: _.get(values, 'inactive', false),
            lastName: _.get(values, 'lastName'),
            notes: _.get(values, 'notes'),
            phone: _.get(values, 'phone'),
            salutation: _.get(values, 'salutation'),
            title: _.get(values, 'title'),
        };

        const token = _.get(this.props.authsession, 'access_token', '');

        MutateActions.createClientContactMutateAsync(parseInt(_.get(this.props.client, 'clientId'), 10), newContact, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.
            if (response.status >= 200 && response.status < 300) {
                this.formDispatch(actions.reset(this.FormModelName));

                // Must manually reset any Selects with a default value of ''
                this.formDispatch(actions.change(`${this.FormModelName}.salutation`, ''));
            } else {
                // Error during client creation...
            }
        });
    }

    // HANDLERS
    public handleEditButton(e: any) {
        this.props.navigateTo(NavigationLinks.clientEdit(this.props.clientId));
    }

    // RENDERERS
    public renderHeaderButtonToolbar = () => {
        let buttonProps = {
            bsSize: 'sm',
            bsStyle: 'info',
        };

        return (
            <div>
                <Well className="header-well-buttontoolbar">
                    <Row>
                        <Col xs={3}>
                            <ButtonToolbar>
                                <Button {...buttonProps} onClick={e => { this.handleEditButton(e); }}>
                                    <i className="glyphicon glyphicon-edit" /> {this.appText('edit-client')}
                                </Button>
                            </ButtonToolbar>
                        </Col>
                    </Row>
                </Well>
            </div>
        );
    }

    public render() {
        const { client, associations, lookups, ...rest } = this.props;

        let sections = {
            address: new Array(),
            associations: new Array(),
            contacts: new Array(),
            details: new Array(),
            enabled: false,
            location: null,
            notes: new Array(),
            title: '',
        };

        if (!client) { return (<div />); }

        if (client) {
            sections.enabled = true;
            // sections.title = _.get(client, 'name', '');
            sections.title = this.appTextPageTitleAppendString(_.get(client, 'name', ''));

            const location = _.get(client, 'location');
            sections.location = location;

            // Address section
            const clientNameLink = (
                <div>
                    <div>{_.get(client, 'name')}</div>
                    <div>
                        <CopyAddressToClipboard locationObj={sections.location} />
                    </div>
                </div>
            );
            sections.address = AddressSection.CreateAddressSectionFields(sections.location, (a, b, c) => this.appText(a, b, c));
            sections.address.unshift(SectionField.CreateSingle(this.appText('client-name'), clientNameLink));
            sections.address.push(SectionField.CreateSingle(this.appText('phone'), Formatters.formatPhoneNumber(_.get(client, 'phone'))));
            sections.address.push(SectionField.CreateSingle(this.appText('fax'), Formatters.formatPhoneNumber(_.get(client, 'fax'))));

            // Details section
            sections.details.push(SectionField.CreateSingle(this.appText('client-id'), _.get(client, 'clientId')));
            sections.details.push(SectionField.CreateSingle(this.appText('client-type'), _.get(client, 'clientType.name')));
            sections.details.push(SectionField.CreateSingle(this.appText('region'), _.get(client, 'region.name')));
            sections.details.push(SectionField.CreateSingle(this.appText('inactive'), _.get(client, 'inactive', false) ? FormCheckbox.RenderCheckedBox() : FormCheckbox.RenderUncheckedBox()));

            // Notes section
            const notes = _.get(client, 'notes', []);
            const clientNotes = (<EntityNotes notes={notes} />);
            if (AppUtilities.isArrayWithLength(notes)) { sections.notes.push(SectionField.CreateSingle('', clientNotes)); }

            // Contacts section
            sections.contacts = this.renderContacts(_.get(client, 'contacts', []));

            // Associations section
            if (AppUtilities.isArrayWithLength(associations)) {
                sections.associations = this.renderAssociations(associations);
            }
        }

        // Add contact form initialization
        const placeholderText = this.appText('select-option.placeholder');
        const salutationOptions = SelectOptions.prepareSelectOptions(_.get(lookups, 'salutations', []), 'salutation', 'salutation', 'sort', 'disabled', 'sort', placeholderText, '', '', true, true);

        const entityDetailLabelColXs = 3;
        const entityDetailValueColXs = 9;

        const page = (
            <div>
                <div>
                    {this.renderHeaderButtonToolbar()}
                </div>

                <WhiteBoxPageSection title={sections.title}>
                    <Row>
                        {/* Left column (address, details & notes sections) */}
                        <Col xs={5}>
                            <div>
                                <EntityDetailSection fields={sections.address} labelColXs={entityDetailLabelColXs} valueColXs={entityDetailValueColXs} enabled={sections.enabled} title={''} />
                            </div>

                            <div>
                                <EntityDetailSection fields={sections.details} labelColXs={entityDetailLabelColXs} valueColXs={entityDetailValueColXs} enabled={sections.enabled} title={''} />
                            </div>
                        </Col>

                        {/* Right column  */}
                        <Col xs={5}>
                            <GoogleMapEmbed locationDocument={sections.location} enabled={sections.enabled} />
                        </Col>
                        { /* <Col xs={5}>
                            <GoogleMapLink locationDocument={sections.location} enabled={sections.enabled} />
                        </Col> */ }
                    </Row>

                    <Row>
                        <Col xs={12}>
                            <EntityDetailSection fields={sections.notes} labelColXs={0} valueColXs={12} enabled={sections.enabled} title={this.appText('client-notes')} />
                        </Col>
                    </Row>
                </WhiteBoxPageSection>

                <Row>
                    <Col xs={5}>
                        <WhiteBoxPageSection title={this.appText('contacts')}>
                            <div className="client-detail-vertical-scroll-container">
                                {sections.contacts}
                            </div>
                        </WhiteBoxPageSection>

                        {/* <WhiteBoxPageSection title={this.appText('add-contact')}>
                            {addContactForm}
                        </WhiteBoxPageSection> */}
                    </Col>

                    {/* Associations section */}
                    <Col xs={5}>
                        <WhiteBoxPageSection title={this.appText('associations')}>
                            <div className="client-detail-vertical-scroll-container">
                                {sections.associations}
                            </div>
                        </WhiteBoxPageSection>
                    </Col>
                </Row>
            </div>
        );

        return (
            <AppComp.RenderPageWithLayout branding={this.props.branding} pageName={sections.title} {...rest}>
                {page}
            </AppComp.RenderPageWithLayout>
        );
    }
}

const getApiUrlLookups = () => ApiEndpoints.getLookupsByKeyUrl([
    LK.LookupKeys.Salutations,
]);

const getApiUrl = props => ApiEndpoints.getClientDetailUrl(props.match.params.clientId, true);

const mapPropsToConfigs = (props) => {
    return [
        ReduxQueries.Queries.getClientDetailRequest(
            getApiUrl(props),
            ReduxQueries.PropsAccessToken(props)
        ),

        ReduxQueries.Queries.getLookupsByKeyRequest(
            getApiUrlLookups(),
            ReduxQueries.PropsAccessToken(props)
        ),
    ];
};

const mapStateToProps = (state, props) => {
    return ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(props), state, props, {
        clientId: props.match.params.clientId,
        client: state.entities.clientDetailClient,
        associations: state.entities.clientDetailAssociations,
    });
};

const mapDispatchToProps = {
    navigateTo: (path) => push(path),
};

const ClientContainer = compose<any>(
    connect(mapStateToProps, mapDispatchToProps),
    connectRequest(mapPropsToConfigs)
)(Client);

export default withRouter(ClientContainer);



// WEBPACK FOOTER //
// ./src/client/index.tsx